import React, {Component} from 'react'
import EkoModal from '../../components/elements/EkoModal'
import {EkoFormButton, EkoFormInputText} from '../../components/elements/EkoForm'

class IdisLineModal extends Component {
    static defaultData() {
        return "";
    }

    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            etiket_no: ""
        };
    }

    closeModal = () => {
        this.props.closeModal();
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.formData !== undefined) {
            this.setState({etiket_no: nextProps.formData || ""});
        }
    }

    onChange = (field, value) => {
        this.setState({ etiket_no: value });
    }

    onSave() {
        const self = this;
        self.setState({saving: false});
        self.props.onSave({item: {etiket_no: this.state.etiket_no}});
    }

    render() {
        return (
            <EkoModal
                bsSize={"large"}
                showModal={this.props.showModal}
                title={"İDİS Etiket Bilgileri"}
                onHide={this.closeModal.bind(this)}
                spinner={this.state.saving}
            >
                <div className="row">
                    <div className="col-md-12">
                        <EkoFormInputText
                            onChange={this.onChange.bind(this)}
                            value={this.state.etiket_no}
                            label="Etiket No"
                            id="etiket_no"
                            isVertical
                            type="text"
                        />
                    </div>
                    <div className="col-md-12">
                        <EkoFormButton
                            label={"Kaydet"}
                            faClass="fa fa-plus"
                            onClick={this.onSave.bind(this)}
                            isLoading={this.state.saving}
                        />
                    </div>
                </div>
            </EkoModal>
        );
    }
}

export default IdisLineModal;
